import { render, staticRenderFns } from "./LoginDescription.vue?vue&type=template&id=6d9af214&scoped=true"
var script = {}
import style0 from "./LoginDescription.vue?vue&type=style&index=0&id=6d9af214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9af214",
  null
  
)

export default component.exports